import React from 'react';
import PropTypes from 'prop-types';

import {
  getPlanSubscriptionStatus,
  getRole,
} from 'constants/localStorageManager';
import { USERS } from 'constants/Users';

export const ButtonHOC = ({ children }) => {
  const { status } = getPlanSubscriptionStatus() || {};
  const isActive = status === 'active';
  const isPendingCancellation = status === 'pending_cancellation';
  const isAdmin = getRole() === USERS.ADMIN;
  const className =
    !isAdmin && !(isActive || isPendingCancellation)
      ? 'pointer-events-none'
      : null;

  return <span className={className}>{children}</span>;
};

ButtonHOC.propTypes = {
  children: PropTypes.any.isRequired,
};

export default ButtonHOC;



// WEBPACK FOOTER //
// ./src/components/hoc/buttonHOC.js